export const homeCarouselData=[
    {
        image:"https://cdn.discordapp.com/attachments/1302849596543991849/1323564058938445874/Website_banner_new_live_now.png?ex=677c38d6&is=677ae756&hm=1bcef9f91cd69e8a7d82faee39efcd62273874b40a51988d5122ab7585fdd498&",
        path:""
    },
    {
        image:"https://cdn.discordapp.com/attachments/1302849596543991849/1323563075588329492/MAYA_Desktop.png?ex=677c37eb&is=677ae66b&hm=0388744111f735f6124ec6f47e1339d2c3cbc78b1e6f518cd45f1e9b966ace34&",
        path:""
    },
    {
        image:"https://cdn.discordapp.com/attachments/1302849596543991849/1323566799836545170/Home_Slider_Dsk_310fabf9-c840-48a2-b66b-b7aaedb39271_1920x900_crop_center_1.png?ex=677c3b63&is=677ae9e3&hm=4b4a87989902259fc94e7e0a722d2b4ac531bfedc2f97a4f0b19d71eac3d24fc&",
        path:""
    },
    {
        image:"https://cdn.discordapp.com/attachments/1302849596543991849/1323565032642187284/Web-Banner-1920-x-860_f866d56f-f60a-4cb6-bb25-e8c7aa033639_50x_2.png?ex=677c39be&is=677ae83e&hm=47de3b2e90aa2617621b9b274e12b015d2a8f075ba604d5ff1f307ab51c37daf&",
        path:""
    }

]

